<template>
  <div id="tabber">

    <span
      class="item"
      @click="select_tab('/')"
      v-bind:class="selected('home')"
    >
      <img
        src="@/assets/home-selected.png"
        v-if="this.selected_tab == 'home'"
      >
      <img
        src="@/assets/home.png"
        v-else
      >
      <div class="tab-text">ホーム</div>
    </span>

    <span
      class="item"
      @click="select_tab('favorites')"
      v-bind:class="selected('favorites')"
    >
      <img
        src="@/assets/star_on.png"
        v-if="this.selected_tab == 'favorites'"
      >
      <img
        src="@/assets/star_off.png"
        v-else
      >
      <div class="tab-text">お気に入り</div>
    </span>

    <span
      class="item"
      @click="select_tab('CallHistory')"
      v-bind:class="selected('CallHistory')"
    >
      <img
        src="@/assets/call_history_on.png"
        v-if="this.selected_tab == 'CallHistory'"
      >
      <img
        src="@/assets/call_history_off.png"
        v-else
      >
      <div class="tab-text">履歴</div>
    </span>

    <span
      class="item"
      @click="select_tab('myPage')"
      v-bind:class="selected('myPage')"
    >
      <img
        src="@/assets/my-page-selected.png"
        v-if="this.selected_tab == 'myPage'"
      >
      <img
        src="@/assets/my-page.png"
        v-else
      >
      <div class="tab-text">マイページ</div>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return { selected_tab: "home" };
  },
  methods: {
    select_tab(tab) {
      this.$router.push(tab);
      if (tab == "/") {
        tab = "home";
      }
      this.selected_tab = tab;
    },
    selected(target_item) {
      if (target_item == this.selected_tab) {
        return "selected";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#tabber {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 10vh;
  text-align: center;
  margin: 0;
  background-color: #fffde4;
  /* box-shadow: 左右の向きpx  上下の向きpx ぼかしpx 広がりpx 色 内側指定; */
  box-shadow: 0px -1px 1px 1px rgb(226, 226, 226);
  .item {
    display: inline-block;
    width: 25vw;
    margin-top: 2vh;
  }
  i {
    font-size: 1.5rem;
  }
  img {
    width: 25%;
  }
  .tab-text {
    font-size: 0.7rem;
  }
}
</style>
